import { render, staticRenderFns } from "./Utilitybar.vue?vue&type=template&id=228b6e34&scoped=true&"
import script from "./Utilitybar.vue?vue&type=script&lang=js&"
export * from "./Utilitybar.vue?vue&type=script&lang=js&"
import style0 from "./Utilitybar.vue?vue&type=style&index=0&id=228b6e34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b6e34",
  null
  
)

export default component.exports